import React, { useEffect, useState } from "react";
import MuPb from "../widgets/MuPb";
import { deleteToken } from "../utils/utils2";
const AppLogout = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    logoutUser();
  }, []);
  function logoutUser() {
    setTimeout(() => {
      deleteToken();
      document.location.href = "/login";
    }, 200);
  }
  if (loading) return <MuPb />;
  return <></>;
};

export default AppLogout;
